<section class="dle-page" aria-labelledby="data-library-title">
  <div class="dle-card">
    <header class="dle-header">
      <div class="dle-header-icon"><mat-icon>query_stats</mat-icon></div>
      <div class="dle-header-main">
        <div class="dle-eyebrow">Grow settings</div>
        <h3 id="data-library-title">Data Library</h3>
        <p>Define the measurements and information workers can record on tasks.</p>
      </div>
      <button class="dle-action-btn" type="button" (click)="migrate()" title="Copy Data Library items to another company">
        <mat-icon>trending_flat</mat-icon>Migrate items
      </button>
    </header>

    <div class="dle-body">
      <div class="dle-add-section">
        <div class="dle-label">Add a data field</div>
        <div class="dle-add-grid">
          <div class="dle-field">
            <label for="new-data-name">Field name</label>
            <input
              id="new-data-name"
              class="dle-input"
              [(ngModel)]="newDefinitionName"
              (keyup.enter)="add()"
              placeholder="e.g. Plant height"
              autocomplete="off">
          </div>
          <div class="dle-field">
            <label for="new-data-unit">Response type</label>
            <select id="new-data-unit" class="dle-select" [(ngModel)]="newDefinitionUnit" (keyup.enter)="add()">
              <option value="" disabled>Select a unit or type</option>
              @for (unit of unitList; track unit.id) {
                <option [value]="unit.id">{{unit.display}}{{unit.suffix ? ' (' + unit.suffix + ')' : ''}}</option>
              }
            </select>
          </div>
          <button class="dle-primary-btn" type="button" [disabled]="!newDefinitionName.trim() || !newDefinitionUnit" (click)="add()">
            <mat-icon>add</mat-icon>Add field
          </button>
        </div>
      </div>

      <div class="dle-library-heading">
        <div>
          <div class="dle-label">Available fields</div>
          <span class="dle-count">{{filteredDataCollectionDefinitions.length}} {{filteredDataCollectionDefinitions.length === 1 ? 'field' : 'fields'}}</span>
        </div>
        <div class="dle-search">
          <mat-icon>search</mat-icon>
          <label class="sr-only" for="data-library-search">Search fields</label>
          <input id="data-library-search" [(ngModel)]="searchText" placeholder="Search by name or unit">
          @if (searchText) {
            <button type="button" aria-label="Clear search" (click)="searchText = ''"><mat-icon>close</mat-icon></button>
          }
        </div>
      </div>

      <div class="dle-list" role="table" aria-label="Data Library fields">
        <div class="dle-list-head" role="row">
          <span role="columnheader">Field name</span>
          <span role="columnheader">Response type</span>
          <span role="columnheader" class="sr-only">Actions</span>
        </div>

        @for (definition of filteredDataCollectionDefinitions; track definition.id) {
          <div class="dle-row" role="row" [class.editing]="editingDefinitionId === definition.id">
            @if (editingDefinitionId === definition.id) {
              <input
                class="dle-input"
                [(ngModel)]="editingDefinitionName"
                (keyup.enter)="applyEdit(definition)"
                (keyup.escape)="cancelEdit()"
                aria-label="Field name">
              <select class="dle-select" [(ngModel)]="editingDefinitionUnit" (keyup.enter)="applyEdit(definition)" aria-label="Response type">
                @for (unit of unitList; track unit.id) {
                  <option [value]="unit.id">{{unit.display}}{{unit.suffix ? ' (' + unit.suffix + ')' : ''}}</option>
                }
              </select>
            } @else {
              <div class="dle-name-cell" role="cell">
                <span class="dle-type-icon"><mat-icon>{{getUnit(definition.unit)?.inputType === 'number' ? 'pin' : getUnit(definition.unit)?.inputType === 'date' ? 'calendar_today' : getUnit(definition.unit)?.inputType === 'time' ? 'schedule' : 'short_text'}}</mat-icon></span>
                <span>{{definition.name}}</span>
              </div>
              <span class="dle-unit" role="cell">{{getUnitLabel(definition.unit)}}</span>
            }

            <div class="dle-row-actions" role="cell">
              @if (editingDefinitionId === definition.id) {
                <button class="dle-text-btn" type="button" (click)="cancelEdit()">Cancel</button>
                <button class="dle-small-primary-btn" type="button" [disabled]="!editingDefinitionName.trim() || !editingDefinitionUnit" (click)="applyEdit(definition)">Done</button>
              } @else {
                <button class="dle-row-btn" type="button" [attr.aria-label]="'Edit ' + definition.name" title="Edit" (click)="edit(definition)"><mat-icon>edit</mat-icon></button>
                <button class="dle-row-btn danger" type="button" [attr.aria-label]="'Remove ' + definition.name" title="Remove" (click)="removeDefinition(definition)"><mat-icon>delete_outline</mat-icon></button>
              }
            </div>
          </div>
        } @empty {
          <div class="dle-empty">
            <span class="dle-empty-icon"><mat-icon>{{searchText ? 'search_off' : 'query_stats'}}</mat-icon></span>
            @if (searchText) {
              <strong>No matching fields</strong>
              <span>Try a different name or unit.</span>
            } @else {
              <strong>No data fields yet</strong>
              <span>Add the first field workers should record.</span>
            }
          </div>
        }
      </div>
    </div>
  </div>

  @if (dirty) {
    <div class="dle-savebar" role="status">
      <span class="dle-savebar-dot"></span>
      <span class="dle-savebar-msg">Unsaved changes</span>
      <span class="dle-savebar-spacer"></span>
      <button class="dle-save-btn ghost" type="button" [disabled]="saving" (click)="getDataLibrary()">Discard</button>
      <button class="dle-save-btn primary" type="button" [disabled]="saving" (click)="save()">
        @if (saving) { <mat-spinner diameter="18" strokeWidth="3"></mat-spinner> }
        @else { <mat-icon>save</mat-icon> }
        Save changes
      </button>
    </div>
  }
</section>
